<div class="player-config-item">
  <div class="">
    <div class="player-config-item-icon" (click)="addOption(playerConfDef)"><i class="fas fa-plus"></i></div>
  </div>
  <div class="body">
    <div class="player-config-item-title">{{playerConfDef?.name}}</div>
    <div class="player-config-item-description" translate>{{'DESCRIPTION_' +replace(playerConfDef?.name)}}</div>
  </div>
</div>
